import { render, staticRenderFns } from "./SlaIcon.vue?vue&type=template&id=590615bc&scoped=true"
import script from "./SlaIcon.vue?vue&type=script&lang=js"
export * from "./SlaIcon.vue?vue&type=script&lang=js"
import style0 from "./SlaIcon.vue?vue&type=style&index=0&id=590615bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590615bc",
  null
  
)

export default component.exports